import {
  GET_PRODUCTOS,
  GET_PRODUCTO,
  TRAE_PRODUCTO_NEW,
  GET_RUBRO,
  ADDEL_PRODUCTO,
  CAMBIA_GAL,
  GET_FLIAS,
  ADD_CART,
  LIMPIA_CARRO,
  SACA_PRODUCTO,
  TRAE_PRODUCTO,
  SEND_PEDIDO,
  GUARDA_PAGO,
  GUARDA_CUSTOM,
  ELIMINA_PROD_CARRO,
} from "../actions";

import {
  GET_PRODUCTOS_ADMIN,
  GET_PRODUCTO_ADMIN,
  UPDATE_PRECIO,
  GET_RUBROSCATS_ADMIN,
  RUBRO_GUARDA,
  CATEGORIA_GUARDA,
  PRODUCTO_GUARDA,
  OPCION_GUARDA,
  CUSTOMDATA_GUARDA,
  CREA_PRECIO,
  BORRA_RUBRO,
  BORRA_CATEGORIA,
  BORRA_PRODUCTO,
  BORRA_OPCION,
  BORRA_PRECIO,
  BORRA_GRUPO,
  UPLOAD_IMG_OPCION,
  UPLOAD_IMG_CUSTOM,
  UPLOAD_IMG_CATEGORIA,
  UPLOAD_IMG_PRODUCTO,
  GRUPOS_GUARDA
} from "../actions/admin";



import {fromJS} from 'immutable';

const initialProductos = {
  lista:[], 
  view:{}, 
  prod:null, 
  carroTemp:[], 
  carro:[], 
  galeria:[], 
  flias:[],
  carro_cant:0,
  end_point:"",
  pedido_ref: "",
  pago_resp: 0,
  inAction: false,
  actualizacion:0,
  contador:0,
  rubros:[],
  categorias:[]
}


const productos = (state=initialProductos, action) => {
  
  const estadoNuevo = Object.assign({}, state);
  const datosNuevo = fromJS(estadoNuevo)

  switch (action.type) {

    case GUARDA_PAGO:
      const guardaPago = datosNuevo.updateIn(['pago_resp'],value =>1)
      return guardaPago.toJSON()

    case SEND_PEDIDO:
      //const endPointCant = datosNuevo.updateIn(['end_point'],value =>action.payload.data.response.init_point)
      //action.payload.data.response.sandbox_init_point;
      //console.log(action.payload.data.response);
      if(action.payload==1){
        const endPointCant = datosNuevo.updateIn(['end_point'],value =>"1")
        const pedidoRef = endPointCant.updateIn(['pedido_ref'], value => action.id)
        return pedidoRef.toJSON()
      }else{ 
        const endPointCant = datosNuevo.updateIn(['end_point'],value =>action.payload.data.response.init_point)
        const pedidoRef = endPointCant.updateIn(['pedido_ref'], value => action.id)
        return pedidoRef.toJSON()
      }

    case GUARDA_CUSTOM:

      const carroAddCustom = state.carro.map( prod =>{
        if(prod.id===action.id_prod){
            prod.custom_objs = action.customObjs
        }
        return prod
      })
      var actualizacionNew = state.actualizacion+1
      const carroNewCustom = datosNuevo.updateIn(['carro'],value => carroAddCustom)
      const carroNewActualizacion = carroNewCustom.updateIn(['actualizacion'],value => actualizacionNew)
      return carroNewActualizacion.toJSON()
    

    case ELIMINA_PROD_CARRO:
      const carrroSinProd = state.carro.filter(item => {
        return item.prod_id != action.id;
      })

      if (carrroSinProd.length > 0) {
        const cantUpdateDel = carrroSinProd.reduce((cantidad, prod) => { return cantidad + prod.cantidad; }, 0);
        const productosConCarroCantNew = datosNuevo.updateIn(["carro_cant"], value => cantUpdateDel);
        const carroActualizado = productosConCarroCantNew.updateIn(["carroTemp"], value => []);
        const carroTempActualizado = carroActualizado.updateIn(["carro"], value => carrroSinProd);
        return carroTempActualizado.toJSON();
      }else{
        const productosConCarroCantNew2 = datosNuevo.updateIn(["carro_cant"], value => 0);
        const carroActualizado2 = productosConCarroCantNew2.updateIn(["carroTemp"], value => []);
        const carroTempActualizado2 = carroActualizado2.updateIn(["carro"], value => []);
        return carroTempActualizado2.toJSON();
      }

    case ADD_CART:
  
      var carro_add =[]
      var carro_add_ids =[]

      state.carroTemp.forEach(prodNew => {
        if (prodNew.cantidad>0){
          var data_temp = prodNew
          
          var prodAnt = state.carro.find(prod => {
            return prodNew.id===prod.id;
          })

          if (prodAnt  && prodAnt.hasOwnProperty("custom_objs")) {
            console.log("TIENE CUSTOM")
            data_temp["custom_objs"] = prodAnt.custom_objs;
          }

          data_temp["precio"] = action.precio;
          carro_add.push(data_temp)
        }
        carro_add_ids.push(prodNew.id);
      });

      const carroQueda = state.carro.filter( prod =>{
        return !carro_add_ids.includes(prod.id)
      })

      const carroNew2 =  [ ...carroQueda, ...carro_add ] 
      //const carroNew2 =  [ ...state.carro, ...carro_add ] 
      const pasaCarro = datosNuevo.updateIn(['carro'],value => carroNew2)

      const limpiaCarro = pasaCarro.updateIn(['carroTemp'],value => [])
      const limpiaCant = limpiaCarro.updateIn(['carro_cant'],value => 0)
      const limpiaEndPoint = limpiaCant.updateIn(['end_point'],value => "")
      return limpiaEndPoint.toJSON()

    case ADDEL_PRODUCTO :
      var newState = Object.assign({}, state);
      const datos = action.data
      var can_total=0
      var prod = action.item 
      prod.cantidad = action.cantidad
      var carro_temp = state.carroTemp.filter((item)=>{
        if(item.id != prod.id){
          can_total=can_total+item.cantidad
          return item
        }
      })


      const carro_new =  [ ...carro_temp, prod ] 

      can_total=can_total+prod.cantidad
      newState.carro_cant=can_total
      newState.carroTemp=carro_new
      return newState


    case SACA_PRODUCTO:
      let carroLista = state.carro.filter((val,i) => {
        return i!=action.pos
      });
      const sacaProducto = datosNuevo.updateIn(['carro'],value => carroLista)
      return sacaProducto.toJSON()


  	case LIMPIA_CARRO:
      const limpiaCarroNew = datosNuevo.updateIn(['carro'],value => [])
      const limpiaEndPointCarro = limpiaCarroNew.updateIn(['end_point'],value => "")
      return limpiaEndPointCarro.toJSON()

    case GET_PRODUCTOS:

      var prods_temp=[]
      action.productos.forEach(function(doc) {
        var data_temp=doc.data()
        data_temp['id']=doc.id
        prods_temp.push(data_temp)
      });


      const productosNew = datosNuevo.updateIn(['lista'],value => prods_temp)
      return productosNew.toJSON()

    case TRAE_PRODUCTO:
      var prods_temp=[]
      var data_temp=action.prod.data()
      data_temp['id']=action.prod.id
      prods_temp.push(data_temp)
      const prodNew = datosNuevo.updateIn(['lista'],value => prods_temp)
      return prodNew.toJSON()

    case GET_PRODUCTO:

      var opciones_temp=[]
      var precios_temp=[]
      var opcion_temp={}
      var opcion_act=0
      action.opciones.forEach(function(doc) {
        var data_temp=doc.data()
        data_temp['id']=doc.id
        if(data_temp.opcion.id!=opcion_act){
          if(opcion_act!=0){
            opciones_temp.push(opcion_temp)
          }
          opcion_act=data_temp.opcion.id
          opcion_temp={
            id:data_temp.opcion.id,
            nombre:data_temp.opcion.nombre,
            items:[]
          }
          opcion_temp.items.push({id:doc.id,nombre:data_temp.nombre,img:data_temp.img})
        }else{
          opcion_temp.items.push({id:doc.id,nombre:data_temp.nombre,img:data_temp.img})
        }
      });
      opciones_temp.push(opcion_temp)

      action.precios.forEach(function(doc) {
        var data_temp=doc.data()
        data_temp['id']=doc.id
        precios_temp.push(data_temp)
      });

      var producto_temp = state.lista.filter((producto)=>{
        return producto.id === action.meta
        /*if(producto.id === action.meta){
        }*/
      })

      if(opciones_temp.length>0){
        producto_temp[0].opciones=opciones_temp
      }

      if(precios_temp.length>0){
        producto_temp[0].precios=precios_temp
      }

      //PARA TRAER LOS PRODUCTOS SI YA TIENE EN EL CARRO
      var traeCarroProd = []
      if(state.carro.length>0){
        traeCarroProd = state.carro.filter((prod)=>{
          return prod.prod_id==action.meta
        })
      }
      
      //FIN

      const productoNew = datosNuevo.updateIn(['prod'],value => producto_temp[0])
      const opcionesNew = productoNew.updateIn(['galeria'],value => opciones_temp)

      if(traeCarroProd.length>0){
        const cantUpdate =traeCarroProd.reduce( (cantidad, prod) => { return cantidad + prod.cantidad; }, 0);
        const productosConCarroCantNew = opcionesNew.updateIn(['carro_cant'],value => cantUpdate)
        const productosConCarroNew = productosConCarroCantNew.updateIn(['carroTemp'],value => traeCarroProd)
        return productosConCarroNew.toJSON()
      }else{
        const productosConCarroCantLimpia = opcionesNew.updateIn(['carro_cant'],value => 0)
        const productosConCarroLimpia = productosConCarroCantLimpia.updateIn(['carroTemp'],value => [])
        return productosConCarroLimpia.toJSON()   
      }


    case  TRAE_PRODUCTO_NEW:
      var productos = []
      var opciones_temp = []
      var precios_temp = []
      var opcion_temp = {}
      var opcion_act = 0

      var prod_temp = action.producto.data()
      prod_temp["id"] = action.producto.id;
      productos.push(prod_temp);

      action.opciones.forEach((doc) => {
        var data_temp = doc.data()
        data_temp['id'] = doc.id
        if (data_temp.opcion.id != opcion_act) {
          if (opcion_act != 0) {
            opciones_temp.push(opcion_temp)
          }
          opcion_act = data_temp.opcion.id
          opcion_temp = {
            id: data_temp.opcion.id,
            nombre: data_temp.opcion.nombre,
            items: []
          }
          opcion_temp.items.push({ id: doc.id, nombre: data_temp.nombre, img: data_temp.img })
        } else {
          opcion_temp.items.push({ id: doc.id, nombre: data_temp.nombre, img: data_temp.img })
        }
      });

      opciones_temp.push(opcion_temp)

      action.precios.forEach((doc) =>  {
        var data_temp = doc.data()
        data_temp['id'] = doc.id
        precios_temp.push(data_temp)
      });

      if (opciones_temp.length > 0) productos[0].opciones = opciones_temp
      if (precios_temp.length > 0)  productos[0].precios = precios_temp;

      var traeCarroProd = []
      if (state.carro.length > 0) {
        traeCarroProd = state.carro.filter((prod) => {
          return prod.prod_id == productos[0].id
        })
      }

      const productoNew2 = datosNuevo.updateIn(["prod"], value => productos[0]);
      const opcionesNew2 = productoNew2.updateIn(["galeria"], value => opciones_temp);

      if (traeCarroProd.length > 0) {
        const cantUpdateNew = traeCarroProd.reduce((cantidad, prod) => { return cantidad + prod.cantidad; }, 0);
        const productosConCarroCantNew2 = opcionesNew2.updateIn(["carro_cant"], value => cantUpdateNew);
        const productosConCarroNew2 = productosConCarroCantNew2.updateIn(["carroTemp"], value => traeCarroProd);
        return productosConCarroNew2.toJSON()
      } else {
        const productosConCarroCantLimpia2 = opcionesNew.updateIn(['carro_cant'], value => 0)
        const productosConCarroLimpia2 = productosConCarroCantLimpia2.updateIn(['carroTemp'], value => [])
        return productosConCarroLimpia2.toJSON()
      }


    case CAMBIA_GAL:
      const galNew = datosNuevo.updateIn(['galeria'],value => action.galeria)
      return galNew.toJSON()
    
    case GET_RUBRO:
      return state

    case GET_FLIAS:
      const fliaNew = datosNuevo.updateIn(['flias'],value => action.payload.data.data)
      return fliaNew.toJSON()


    case GET_PRODUCTOS_ADMIN:

      var prods_temp=[]
      action.productos.forEach(function(doc) {
        var data_temp=doc.data()
        data_temp['id']=doc.id
        prods_temp.push(data_temp)
      });
      const productosAdminNew = datosNuevo.updateIn(['lista'],value => prods_temp)
      return productosAdminNew.toJSON()

    case GET_PRODUCTO_ADMIN:
      var precios_temp=[]
      var opciones_temp=[]
      var opcion_temp=null
      var opcion_act=0

      action.opciones.forEach(function(doc) {
        var data_temp=doc.data()
        data_temp['id']=doc.id
        if(data_temp.opcion.id!=opcion_act){
          if(opcion_act!=0){
            opciones_temp.push(opcion_temp)
          }
          opcion_act=data_temp.opcion.id
          opcion_temp={
            id:data_temp.opcion.id,
            nombre:data_temp.opcion.nombre,
            items:[]
          }
          opcion_temp.items.push({
            id: doc.id,
            nombre: data_temp.nombre,
            img: data_temp.img,
            estado: data_temp.estado
          });
        }else{
          opcion_temp.items.push({
            id: doc.id,
            nombre: data_temp.nombre,
            img: data_temp.img,
            estado: data_temp.estado
          });
        }
      });

      if(opcion_temp!=null){
        opciones_temp.push(opcion_temp)
      }

      action.precios.forEach(function(doc) {
        var data_temp=doc.data()
        data_temp['id']=doc.id
        precios_temp.push(data_temp)
      });

      var producto_temp = state.lista.filter((producto)=>{
        if(producto.id === action.meta){
          return producto
        }
      })

      if(opciones_temp.length>0){
        producto_temp[0].opciones=opciones_temp
      }else{
        producto_temp[0].opciones = []
      }
      if(precios_temp.length>0){
        producto_temp[0].precios=precios_temp
      } else {
        producto_temp[0].precios = [];
      }

      const productoAdminNew = datosNuevo.updateIn(['prod'],value => producto_temp[0])
      const opcionesAdminNew = productoAdminNew.updateIn(['galeria'],value => opciones_temp)
      const opcionesAdminCounterNew = opcionesAdminNew.updateIn(["contador"], value => (state.contador+1));
      return opcionesAdminCounterNew.toJSON();

    case UPDATE_PRECIO:
      var newProd = Object.assign({}, state.prod);
      var precios_temp=[]
      newProd.precios.forEach( (doc) => {
        if(doc.id==action.id){
          var precio = {id:doc.id,cantidad:doc.cantidad,precio:action.precio}
          precios_temp.push(precio)
        }else{
          precios_temp.push(doc)
        }
      });
      newProd.precios=precios_temp
      const precioAdminNew = datosNuevo.updateIn(['prod'],value => newProd)
      return precioAdminNew.toJSON()
    
    case GET_RUBROSCATS_ADMIN:
      var rubros_temp = []
      action.rubros.forEach((rubro) => {
        var r_temp = rubro.data();
        r_temp["id"] = rubro.id;
        rubros_temp.push(r_temp);
      }); 

      var categorias_temp = []
      action.categorias.forEach((cat) => {
        var c_temp = cat.data();
        c_temp["id"] = cat.id;
        categorias_temp.push(c_temp);
      });

      const rubrosNew = datosNuevo.updateIn(['rubros'], value => rubros_temp)
      const categorasNew = rubrosNew.updateIn(["categorias"], value => categorias_temp);
      return categorasNew.toJSON();


      case RUBRO_GUARDA:

        if(action.act=="add"){
          var rubrosAddNew = datosNuevo.updateIn(["rubros"], list =>
            list.push(action.datos)
          );
        }else{
          var index = datosNuevo.get('rubros').findIndex(item => item.get("id") == action.datos.id);
          var rubrosAddNew = datosNuevo.setIn(["rubros", index], action.datos);
        }
        const rubrosAddContador = rubrosAddNew.updateIn(["contador"], value => (state.contador+1));
        console.log(rubrosAddContador.toJSON())
        return rubrosAddContador.toJSON();

      case CATEGORIA_GUARDA:
        if (action.act == "add") {
          var categoriasAddNew = datosNuevo.updateIn(["categorias"], list =>
            list.push(action.datos)
          );
        } else {
          var index = datosNuevo.get('categorias').findIndex(item => item.get("id") == action.id);
          console.log(index)
          var categoriasAddNew = datosNuevo.setIn(["categorias", index], action.datos);
        }
        const categoriasAddContador = categoriasAddNew.updateIn(["contador"], value => (state.contador+1));
        return categoriasAddContador.toJSON();

      case PRODUCTO_GUARDA:
        if (action.act == "add") {
          var productoListaAddNew = datosNuevo.updateIn(["lista"], list =>
            list.push(action.datos)
          );
        } else {
          var index = datosNuevo.get('lista').findIndex(item => item.get("id") == action.datos.id);
          var productoListaAddNew = datosNuevo.setIn(["lista", index], action.datos);
        }
        const productoAddNew = productoListaAddNew.updateIn(['prod'], value => action.datos)
        const productoAddContador = productoAddNew.updateIn(["contador"], value => (state.contador+1));
        return productoAddContador.toJSON();

      case OPCION_GUARDA:

        var grupoNombre = action.datos.opcion.nombre
        var grupoId = action.datos.opcion.id
        var indexOpcion = datosNuevo.getIn(['prod', 'opciones']).findIndex(item => item.get("id") == grupoId);
        
        if (action.act == "add") {
          if(indexOpcion>0){
            var opcionListaAddNew = datosNuevo.updateIn(["prod", "opciones", indexOpcion, "items"], list => list.push(
              { 
                id: action.datos.id,
                nombre: action.datos.nombre,
                img: action.datos.img,
                orden: action.datos.orden,
                estado: action.datos.estado 
              }
              ));
          }else{
            var opcion = {
              id:grupoId,
              nombre:grupoNombre,
              items: [{
                id: action.datos.id,
                nombre: action.datos.nombre,
                img: action.datos.img,
                orden: action.datos.orden,
                estado: action.datos.estado
              }]
            }
            var opcionListaAddNew = datosNuevo.updateIn(["prod", "opciones"], list => list.push(opcion));
          }
        } else {
          var indexItem = datosNuevo.getIn(['prod', 'opciones', indexOpcion ,'items']).findIndex(item => item.get("id") == action.datos.id);
          var opcionListaAddNew = datosNuevo.updateIn(["prod", "opciones", indexOpcion, "items", indexItem], list => list.push({
            id: action.datos.id,
            nombre: action.datos.nombre,
            img: action.datos.img,
            orden: action.datos.orden,
            estado: action.datos.estado
          }));
        }
        const opcionAddContador = opcionListaAddNew.updateIn(["contador"], value => (state.contador+1));
        return opcionAddContador.toJSON();

      case CUSTOMDATA_GUARDA:

        var index = datosNuevo.get('lista').findIndex(item => item.get("id") == action.id_producto);
        var customListaAddNew = datosNuevo.setIn(["lista", index,'custom_data'], action.datos);
        var prod = customListaAddNew.get('lista').find(item => item.get("id") == action.id_producto);
        const customAddNew = customListaAddNew.updateIn(['prod'], value => prod)
        const customAddContador = customAddNew.updateIn(["contador"], value => (state.contador+1));
        return customAddContador.toJSON();


      case GRUPOS_GUARDA:
        var index = datosNuevo.get('lista').findIndex(item => item.get("id") == action.id_producto);
        var prod = datosNuevo.get('lista').find(item => item.get("id") == action.id_producto);
        const listaGruposAddNew = datosNuevo.setIn(["lista", index, 'grupos'], action.datos);
        const prodGruposAddNew = listaGruposAddNew.updateIn(["prod", "grupos"], value => action.datos);
        const gruposAddContador = prodGruposAddNew.updateIn(["contador"], value => state.contador + 1);
        return gruposAddContador.toJSON();

      case BORRA_GRUPO:
        var index = datosNuevo.get('lista').findIndex(item => item.get("id") == action.id_producto);
        const listaGrupoDelNew = datosNuevo.setIn(["lista", index, 'grupos'], action.grupos);
        const prodGrupoDelNew = listaGrupoDelNew.updateIn(["prod", "grupos"], value => action.grupos);
        const grupoDelContador = prodGrupoDelNew.updateIn(["contador"], value => state.contador + 1);
        return grupoDelContador.toJSON();

      case CREA_PRECIO:
        var preciosListaAddNew = datosNuevo.updateIn(["prod", "precios"], list => list.push(action.datos));
        const preciosAddContador = preciosListaAddNew.updateIn(["contador"], value => (state.contador+1));
        return preciosAddContador.toJSON();
      
      case BORRA_RUBRO:
        var index = datosNuevo.get('rubros').findIndex(item => item.get("id") == action.id_rubro);
        const rubrosDelNew = datosNuevo.deleteIn(["rubros", index]);
        const rubrosDelContador = rubrosDelNew.updateIn(["contador"], value => (state.contador+1));
        return rubrosDelContador.toJSON();
      
      case BORRA_CATEGORIA:
        var index = datosNuevo.get('categorias').findIndex(item => item.get("id") == action.id_categoria);
        const categoriasDelNew = datosNuevo.deleteIn(["categorias", index])
        const categoriasDelContador = categoriasDelNew.updateIn(["contador"], value => (state.contador+1));
        return categoriasDelContador.toJSON();
      
      case BORRA_PRODUCTO:
        var index = datosNuevo.get('lista').findIndex(item => item.get("id") == action.id_producto);
        /*console.log(action.id_producto)
        const productosTempDelNew = datosNuevo.getIn(["lista"]).filter(prod => {
            console.log(prod.get("id"));
            return prod.get("id") != action.id_producto;
        })

        console.log(productosDelNew.getIn(["lista"]).toJSON())
        const productosDelNew = datosNuevo.updateIn(["lista"], value => productosTempDelNew);*/
        const productosDelNew = datosNuevo.deleteIn(["lista", index]);
        const productoDelNew = productosDelNew.setIn(["prod"],null);
        const productosDelContador = productoDelNew.updateIn(["contador"], value => (state.contador+1));
        return productosDelContador.toJSON();   

      case BORRA_OPCION:

        var prodIndex = datosNuevo.get('lista').findIndex(item => item.get("id") == action.datos.id_producto);
        var index = datosNuevo.get('lista', prodIndex, 'opciones').findIndex(item => item.get("id") == action.id_opcion);
        
        const opcionListaDelNew = datosNuevo.deleteIn(["lista", prodIndex,"opciones",index]);
        var prod = opcionListaDelNew.get('lista').find(item => item.get("id") == action.datos.id_producto);

        const opcionDelNew = opcionListaDelNew.updateIn(['prod'], value => prod)
        const opcionDelContador = opcionDelNew.updateIn(["contador"], value => (state.contador+1));
        return opcionDelContador.toJSON();
      
      case BORRA_PRECIO:

        var prodIndex = datosNuevo.get('lista').findIndex(item => item.get("id") == action.id_producto);
        var index = datosNuevo.get('lista', prodIndex, 'precios').findIndex(item => item.get("id") == action.id_precio);
        
        const preciosListaDelNew = datosNuevo.deleteIn(["lista", prodIndex, "precios", index]);
        var prod = preciosListaDelNew.get('lista').find(item => item.get("id") == action.id_producto);

        const preciosDelNew = preciosListaDelNew.updateIn(['prod'], value => prod)
        const preciosDelContador = preciosDelNew.updateIn(["contador"], value => (state.contador+1));
        return preciosDelContador.toJSON();

      case UPLOAD_IMG_OPCION:
        var grupoIndex = datosNuevo.getIn(['prod','opciones']).findIndex(item => item.get("id") == action.id_grupo);
        var itemIndex = datosNuevo.getIn(['prod', 'opciones', grupoIndex, 'items']).findIndex(item => item.get("id") == action.id_opcion);
        const cambiaImgOpcionNew = datosNuevo.updateIn(['prod', 'opciones', grupoIndex, 'items',itemIndex,"img"], value =>action.img);
        const imgOpcionContador = cambiaImgOpcionNew.updateIn(["contador"], value => (state.contador + 1));
        return imgOpcionContador.toJSON();

      case UPLOAD_IMG_CUSTOM:
        const imgCustomContador = datosNuevo.updateIn(["contador"], value => state.contador + 1);
        return imgCustomContador.toJSON();

      case UPLOAD_IMG_CATEGORIA:
        var index = datosNuevo.get('categorias').findIndex(item => item.get("id") == action.id_categoria);
        const cambiaImgCatNew = datosNuevo.updateIn(['categorias', index, "img"], value => action.img);
        const imgCategoriaContador = cambiaImgCatNew.updateIn(["contador"], value => (state.contador + 1));
        return imgCategoriaContador.toJSON();

      case UPLOAD_IMG_PRODUCTO:
        var index = datosNuevo.get('lista').findIndex(item => item.get("id") == action.id_producto);
        var productoImgListaNew = datosNuevo.setIn(["lista", index,"img"], action.img);
        const productoImgNew = productoImgListaNew.setIn(["prod", "img"], action.img);
        const productoImageContador = productoImgNew.updateIn(["contador"], value => (state.contador + 1));
        return productoImageContador.toJSON();

    default:
      return state
  }
}

export default productos


// WEBPACK FOOTER //
// ./src/reducers/productos.js